/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Content_TitleInputs */

const en_legal_content_title = /** @type {(inputs: Legal_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content and Reporting Policy`)
};

const pl_legal_content_title = /** @type {(inputs: Legal_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polityka treści i zgłoszeń`)
};

/**
* | output |
* | --- |
* | "Content and Reporting Policy" |
*
* @param {Legal_Content_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_content_title = /** @type {((inputs?: Legal_Content_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Content_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_content_title(inputs)
	return en_legal_content_title(inputs)
});